"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _react = _interopRequireWildcard(require("react"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UIFormControl = _interopRequireDefault(require("UIComponents/form/UIFormControl"));

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UITextInput = _interopRequireDefault(require("UIComponents/input/UITextInput"));

var _UIToggle = _interopRequireDefault(require("UIComponents/input/UIToggle"));

var _UIHelpIcon = _interopRequireDefault(require("UIComponents/icon/UIHelpIcon"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UIFileAttachment = _interopRequireDefault(require("UIComponents/attachment/UIFileAttachment"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _url = require("../../utils/url");

var _link = require("../../constants/link");

var _constants = require("../../api/constants");

var _hubl = require("../../utils/hubl");

var _StyleProtectedSelectItem = _interopRequireDefault(require("../style-protected/StyleProtectedSelectItem"));

var _PageLinkField = _interopRequireDefault(require("./PageLinkField"));

var _MeetingLinkField = _interopRequireDefault(require("./MeetingLinkField"));

var _requiredBy = _interopRequireDefault(require("../../utils/requiredBy"));

var _AnchorLinkField = _interopRequireDefault(require("./AnchorLinkField"));

var _anchor = require("../../utils/anchor");

var i18nKey = function i18nKey(suffix) {
  return "RichTextLib.links." + suffix;
};

var LinkFields =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkFields, _Component);

  function LinkFields() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, LinkFields);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(LinkFields)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleLinkTypeChange = function (_ref) {
      var value = _ref.target.value;

      _this.props.onLinkTypeChange(value);
    };

    _this.handleFileSelection = function () {
      var _this$props = _this.props,
          onSelectFile = _this$props.onSelectFile,
          onUpdate = _this$props.onUpdate;
      onSelectFile(function (file) {
        onUpdate({
          href: file.url,
          linkDisplayName: file.title + "." + file.extension,
          fileMeta: {
            fileName: file.title + "." + file.extension,
            size: file.size,
            type: file.type
          }
        });
      });
    };

    return _this;
  }

  (0, _createClass2.default)(LinkFields, [{
    key: "renderUrlSearchInput",
    value: function renderUrlSearchInput() {
      var _this$props2 = this.props,
          href = _this$props2.href,
          onUpdate = _this$props2.onUpdate,
          linkType = _this$props2.linkType,
          shouldAutoFocus = _this$props2.shouldAutoFocus;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.URL + ".label")),
        className: "m-top-0"
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: shouldAutoFocus,
        "data-test-id": "url-search-input",
        value: linkType === _link.LinkTypes.URL ? href : '',
        onKeyDown: this.props.onUrlKeyDown,
        onChange: function onChange(_ref2) {
          var value = _ref2.target.value;
          // may want to save protocol appending for onRemove so it doesn't just suddenly add it while typing
          var newHref = (0, _url.isLikelyUrlWithoutProtocol)(value) ? "http://" + value : value;
          onUpdate({
            href: newHref,
            linkDisplayName: newHref
          });
        }
      }));
    }
  }, {
    key: "renderEmailInput",
    value: function renderEmailInput() {
      var _this$props3 = this.props,
          href = _this$props3.href,
          onUpdate = _this$props3.onUpdate,
          linkType = _this$props3.linkType,
          shouldAutoFocus = _this$props3.shouldAutoFocus;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL + ".label")),
        className: "m-top-0"
      }, _react.default.createElement(_UITextInput.default, {
        autoFocus: shouldAutoFocus,
        onKeyDown: this.props.onUrlKeyDown,
        "data-test-id": "email-address-input",
        value: linkType === _link.LinkTypes.EMAIL ? href.replace(/^mailto:/, '') : '',
        onChange: function onChange(_ref3) {
          var value = _ref3.target.value;
          var newHref = "mailto:" + value;
          onUpdate({
            href: newHref,
            linkDisplayName: value
          });
        }
      }));
    }
  }, {
    key: "renderPageSelection",
    value: function renderPageSelection() {
      var _this$props4 = this.props,
          href = _this$props4.href,
          onUpdate = _this$props4.onUpdate,
          linkType = _this$props4.linkType,
          dropdownClassName = _this$props4.dropdownClassName,
          fetchPages = _this$props4.fetchPages,
          shouldAutoFocus = _this$props4.shouldAutoFocus;
      return _react.default.createElement(_PageLinkField.default, {
        autoFocus: shouldAutoFocus,
        url: linkType === _link.LinkTypes.PAGE ? href : '',
        fetchPages: fetchPages,
        dropdownClassName: dropdownClassName,
        onChange: function onChange(_ref4) {
          var url = _ref4.url,
              pageName = _ref4.pageName;
          onUpdate({
            href: url,
            linkDisplayName: pageName
          });
        }
      });
    }
  }, {
    key: "renderFileSelection",
    value: function renderFileSelection() {
      var _this2 = this;

      var currentFileMeta = this.props.currentFileMeta;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.FILE + ".label")),
        className: "m-top-0",
        help: currentFileMeta ? _react.default.createElement(_Small.default, {
          style: {
            lineHeight: 'inherit'
          }
        }, _react.default.createElement(_UIButton.default, {
          onClick: this.handleFileSelection,
          use: "link",
          size: "xs"
        }, _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey("linkTypes." + _link.LinkTypes.FILE + ".replace")
        }))) : null
      }, currentFileMeta ? _react.default.createElement(_UIFileAttachment.default, {
        className: "hs-link-field--file-attachment",
        onCloseClick: function onCloseClick() {
          return _this2.props.onUpdate({
            fileMeta: null,
            href: ''
          });
        },
        fileName: currentFileMeta.fileName,
        fileInfo: _I18n.default.formatSize(currentFileMeta.size),
        fileType: currentFileMeta.type,
        closeable: true
      }) : _react.default.createElement(_UIButton.default, {
        use: "tertiary-light",
        onClick: this.handleFileSelection,
        size: "small"
      }, _I18n.default.text(i18nKey('selectFile'))));
    }
  }, {
    key: "renderEmailSubscriptionSelection",
    value: function renderEmailSubscriptionSelection() {
      var _this$props5 = this.props,
          href = _this$props5.href,
          onUpdate = _this$props5.onUpdate,
          linkType = _this$props5.linkType,
          dropdownClassName = _this$props5.dropdownClassName;
      return _react.default.createElement(_UIFormControl.default, {
        label: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL_SUBSCRIPTION + ".label")),
        className: "m-top-0"
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        searchable: true,
        value: linkType === _link.LinkTypes.EMAIL_SUBSCRIPTION ? (0, _hubl.getHublVariable)(href) : '',
        onSelectedOptionChange: function onSelectedOptionChange(_ref5) {
          var data = _ref5.target.value;
          onUpdate({
            href: "{{ " + data.value + " }}",
            linkDisplayName: data.text
          });
        },
        options: [{
          text: _I18n.default.text(i18nKey('emailSystemLinks.unsubscribe')),
          help: _I18n.default.text(i18nKey('emailSystemLinks.unsubscribeHelpText')),
          value: _hubl.EmailSystemHublVariables.UNSUBSCRIBE
        }, {
          text: _I18n.default.text(i18nKey('emailSystemLinks.subscriptionConfirmation')),
          help: _I18n.default.text(i18nKey('emailSystemLinks.subscriptionConfirmationHelpText')),
          value: _hubl.EmailSystemHublVariables.SUBSCRIPTION_CONFIRMATION
        }, {
          text: _I18n.default.text(i18nKey('emailSystemLinks.unsubscribeAll')),
          help: _I18n.default.text(i18nKey('emailSystemLinks.unsubscribeAllHelpText')),
          value: _hubl.EmailSystemHublVariables.UNSUBSCRIBE_ALL
        }, {
          text: _I18n.default.text(i18nKey('emailSystemLinks.viewAsWebpage')),
          help: _I18n.default.text(i18nKey('emailSystemLinks.viewAsWebpageHelpText')),
          value: _hubl.EmailSystemHublVariables.VIEW_AS_WEBPAGE
        }],
        placeholder: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL_SUBSCRIPTION + ".placeholder"))
      }));
    }
  }, {
    key: "renderMeetingSelection",
    value: function renderMeetingSelection() {
      var _this$props6 = this.props,
          userId = _this$props6.userId,
          href = _this$props6.href,
          fetchMeetings = _this$props6.fetchMeetings,
          dropdownClassName = _this$props6.dropdownClassName,
          onUpdate = _this$props6.onUpdate;
      return _react.default.createElement(_MeetingLinkField.default, {
        userId: userId,
        url: href,
        fetchMeetings: fetchMeetings,
        dropdownClassName: dropdownClassName,
        onChange: function onChange(_ref6) {
          var url = _ref6.url,
              meetingName = _ref6.meetingName;
          return onUpdate({
            href: url,
            linkDisplayName: meetingName
          });
        }
      });
    }
  }, {
    key: "renderAnchorInput",
    value: function renderAnchorInput() {
      var _this$props7 = this.props,
          href = _this$props7.href,
          fetchAnchors = _this$props7.fetchAnchors,
          onUpdate = _this$props7.onUpdate,
          dropdownClassName = _this$props7.dropdownClassName;
      return _react.default.createElement(_AnchorLinkField.default, {
        anchor: (0, _anchor.deserializeAnchorFromLink)(href),
        fetchAnchors: fetchAnchors,
        dropdownClassName: dropdownClassName,
        onChange: function onChange(_ref7) {
          var anchorName = _ref7.anchorName;
          onUpdate({
            href: (0, _anchor.serializeAnchorAsLink)(anchorName),
            linkDisplayName: anchorName
          });
        }
      });
    }
  }, {
    key: "renderUrlField",
    value: function renderUrlField() {
      var linkType = this.props.linkType;

      switch (linkType) {
        case _link.LinkTypes.URL:
          return this.renderUrlSearchInput();

        case _link.LinkTypes.PAGE:
          return this.renderPageSelection();

        case _link.LinkTypes.EMAIL:
          return this.renderEmailInput();

        case _link.LinkTypes.FILE:
          return this.renderFileSelection();

        case _link.LinkTypes.EMAIL_SUBSCRIPTION:
          return this.renderEmailSubscriptionSelection();

        case _link.LinkTypes.MEETING:
          return this.renderMeetingSelection();

        case _link.LinkTypes.ANCHOR:
          return this.renderAnchorInput();

        default:
          return null;
      }
    }
  }, {
    key: "renderLinkSelection",
    value: function renderLinkSelection() {
      var _this$props8 = this.props,
          linkType = _this$props8.linkType,
          useEmailSubscription = _this$props8.useEmailSubscription,
          allowFileDownload = _this$props8.allowFileDownload,
          allowMeetingLink = _this$props8.allowMeetingLink,
          allowAnchorLinks = _this$props8.allowAnchorLinks,
          useNoLinkOption = _this$props8.useNoLinkOption,
          dropdownClassName = _this$props8.dropdownClassName,
          scopes = _this$props8.scopes;
      var linkTypeOptions = [{
        text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL + ".option")),
        value: _link.LinkTypes.EMAIL
      }, {
        text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.URL + ".option")),
        value: _link.LinkTypes.URL
      }];

      if (allowFileDownload) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.FILE + ".option")),
          value: _link.LinkTypes.FILE
        });
      }

      if (scopes.includes(_constants.CONTENT_ACCESS_SCOPE) || scopes.includes(_constants.KNOWLEDGE_ACCESS_SCOPE)) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.PAGE + ".option")),
          value: _link.LinkTypes.PAGE
        });
      }

      if (useEmailSubscription) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.EMAIL_SUBSCRIPTION + ".option")),
          value: _link.LinkTypes.EMAIL_SUBSCRIPTION
        });
      }

      if (allowMeetingLink) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.MEETING + ".option")),
          value: _link.LinkTypes.MEETING
        });
      }

      if (allowAnchorLinks) {
        linkTypeOptions.push({
          text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.ANCHOR + ".option")),
          value: _link.LinkTypes.ANCHOR
        });
      } // re-order alphabetically based on option label


      linkTypeOptions.sort(function (a, b) {
        return a.text > b.text;
      }); // place no-link at the top since it's the default zero-state

      if (useNoLinkOption) linkTypeOptions.unshift({
        text: _I18n.default.text(i18nKey("linkTypes." + _link.LinkTypes.NONE + ".option")),
        value: _link.LinkTypes.NONE
      });
      return _react.default.createElement("div", {
        className: "m-bottom-6"
      }, _react.default.createElement(_UIFormControl.default, {
        label: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('linkTo')
        }),
        className: "m-bottom-2"
      }, _react.default.createElement(_UISelect.default, {
        dropdownClassName: dropdownClassName,
        value: linkType,
        placeholder: _react.default.createElement(_FormattedMessage.default, {
          message: i18nKey('linkTypes.placeholder')
        }),
        options: linkTypeOptions,
        searchable: false,
        "data-test-id": "link-type-select",
        onChange: this.handleLinkTypeChange,
        optionRenderer: function optionRenderer(option) {
          return _react.default.createElement(_StyleProtectedSelectItem.default, {
            className: "private-typeahead-result-label",
            title: option.text
          }, _react.default.createElement("span", null, option.text));
        }
      })), this.renderUrlField());
    }
  }, {
    key: "renderToggles",
    value: function renderToggles() {
      var _this$props9 = this.props,
          externalLink = _this$props9.externalLink,
          noFollow = _this$props9.noFollow,
          linkType = _this$props9.linkType,
          showRefAndTargetControls = _this$props9.showRefAndTargetControls,
          onUpdate = _this$props9.onUpdate;
      if (!showRefAndTargetControls || linkType === _link.LinkTypes.NONE) return null;
      return _react.default.createElement("div", null, linkType !== _link.LinkTypes.EMAIL && linkType !== _link.LinkTypes.FILE ? _react.default.createElement("div", {
        className: "m-bottom-2 justify-between align-center"
      }, _react.default.createElement(_UIFormLabel.default, {
        htmlFor: "link-toggle-open-new"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('openNewWindow')
      })), _react.default.createElement(_UIToggle.default, {
        id: "link-toggle-open-new",
        size: "extra-small",
        checked: externalLink,
        onChange: function onChange(_ref8) {
          var checked = _ref8.target.checked;
          onUpdate({
            externalLink: checked
          });
        }
      })) : null, _react.default.createElement("div", {
        className: "m-bottom-2 justify-between align-center"
      }, _react.default.createElement(_UIFormLabel.default, {
        htmlFor: "link-toggle-nofollow"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: i18nKey('tellNoFollow')
      }), _react.default.createElement(_UIHelpIcon.default, {
        className: "m-left-1",
        title: _I18n.default.text(i18nKey('noFollowPopover')),
        tooltipProps: {
          placement: 'top'
        }
      })), _react.default.createElement(_UIToggle.default, {
        id: "link-toggle-nofollow",
        size: "extra-small",
        checked: noFollow,
        onChange: function onChange(_ref9) {
          var checked = _ref9.target.checked;
          onUpdate({
            noFollow: checked
          });
        }
      })));
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null, this.renderLinkSelection(), this.renderToggles());
    }
  }]);
  return LinkFields;
}(_react.Component);

exports.default = LinkFields;
LinkFields.propTypes = {
  externalLink: _react.PropTypes.bool.isRequired,
  noFollow: _react.PropTypes.bool.isRequired,
  href: _react.PropTypes.string.isRequired,
  onUpdate: _react.PropTypes.func.isRequired,
  onLinkTypeChange: _react.PropTypes.func.isRequired,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: (0, _requiredBy.default)('allowMeetingLink', _react.PropTypes.func),
  fetchAnchors: (0, _requiredBy.default)('allowAnchorLinks', _react.PropTypes.func),
  linkType: _react.PropTypes.oneOf((0, _link.getAllLinkTypesForProps)()),
  onSelectFile: (0, _requiredBy.default)('allowFileDownload', _react.PropTypes.func),
  onUrlKeyDown: _react.PropTypes.func.isRequired,
  currentFileMeta: _react.PropTypes.object,
  dropdownClassName: _react.PropTypes.string,
  showRefAndTargetControls: _react.PropTypes.bool,
  useEmailSubscription: _react.PropTypes.bool,
  allowFileDownload: _react.PropTypes.bool,
  allowMeetingLink: _react.PropTypes.bool,
  allowAnchorLinks: _react.PropTypes.bool,
  useNoLinkOption: _react.PropTypes.bool,
  shouldAutoFocus: _react.PropTypes.bool,
  scopes: _react.PropTypes.array,
  userId: _react.PropTypes.number
};
LinkFields.defaultProps = {
  useEmailSubscription: false,
  allowFileDownload: true,
  allowAnchorLinks: false,
  useNoLinkOption: false,
  shouldAutoFocus: true,
  scopes: []
};
module.exports = exports.default;